// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"98e5a3b5","163":"bc9531b0","182":"ac8ee21f","236":"9db9890b","335":"d1b21496","384":"0ad488a4","656":"5f201592","744":"03774389","760":"c7230a92","810":"e05688a4","811":"c38f14ed","836":"21781c23","941":"720dbfaa","990":"066379b5"}[chunkId] + ".chunk.js";
};